module.exports = __webpack_public_path__ + "static/media/daisie-flipbook-black.4d1513ec.png";